import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Modal, Toast, ListView, Icon } from 'antd-mobile';
import {post} from '../../utils/request';
import { getUrlParam, href } from '../../utils/util';
import api from './api';

import './index.less';

const NUM_SECTIONS = 50;
const NUM_ROWS_PER_SECTION = 50;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];
function genData(pIndex = 0) {
    for (let i = 0; i < NUM_SECTIONS; i++) {
        const ii = (pIndex * NUM_SECTIONS) + i;
        const sectionName = `Section ${ii}`;
        sectionIDs.push(sectionName);
        dataBlobs[sectionName] = sectionName;
        rowIDs[ii] = [];

        for (let jj = 0; jj < NUM_ROWS_PER_SECTION; jj++) {
            const rowName = `S${ii}, R${jj}`;
            rowIDs[ii].push(rowName);
            dataBlobs[rowName] = rowName;
        }
    }
    sectionIDs = [...sectionIDs];
    rowIDs = [...rowIDs];
}

class peaceSharkRank extends React.Component {
    constructor(...args) {
        super(...args);

        const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID];
        const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];
        const dataSource = new ListView.DataSource({
            getRowData,
            getSectionHeaderData: getSectionData,
            rowHasChanged: (row1, row2) => row1 !== row2,
            sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 10 / 4,
            data: [],
            skipCount: 0,
            pageSize: 50,
            urlOps:{}
        };
    }

    componentDidMount() {
    }

    componentWillMount() {
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                // let viewPort = this.viewPort();
                // if (
                //     viewPort.ios ||
                //     viewPort.iPhone ||
                //     viewPort.iPad
                // ) {
                //     if(window.webkit){
                //         window.webkit.messageHandlers.login.postMessage('');
                //     }
                // } else {
                //     if(window.huilian){
                //         window.huilian.login('');
                //     }
                // }
                Toast.fail('您还未登录，请登录后再操作',999);
                return;
            }
            this.setState({
                urlOps: ops
            },()=>{
                this.init()
            });
        }
       
    }

    init(){
        sectionIDs = [];
        rowIDs = [];
        dataBlobs = {};
        pageIndex = 0;
        
        genData();
        this.getList();
    }

    getList(){
        const {skipCount, pageSize, urlOps} = this.state;
    
        post({
            url: api.queryCourseRankList + '?app_stoken=' + urlOps.app_stoken + '&activity=365',
          data:{
            activityCode: getUrlParam('activityCode'),
            pageSize: pageSize
          }
        }).then((res) => {
            // console.log('查询列表', res)
            // Toast.info(res.msg,1);
            if(res.result === 'success' && res.data || res.data.length > 0){
              this.setState({
                data: res.data
              },()=>{
                if(sectionIDs.length >= res.count){
                  this.setState({
                    hasMore: false
                  });
                }
                //   const hei = res.data.length>0?document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop-12:0;
                  this.setState({
                    dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
                    isLoading: false,
                    // height: hei,
                  });
              });
            }else{
              
            }
        }, (res)=>{
            console.log('查询列表失败', res)
        });
    }
    
    
    onEndReached = (event) => {
        // load new data
        // hasMore: from backend data, indicates whether it is the last page, here is false
        if (this.state.isLoading || !this.state.hasMore) {
            return;
        }
        console.log('reach end', event);
        this.setState({ isLoading: true });
        setTimeout(() => {
            pageIndex++;
            genData(pageIndex);
            this.setState({
                skipCount: pageIndex
            },()=>{
                this.getList()
            });
        }, 1000);
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是否web应该程序，没有头部与底部
        };
    }

    render() {
        const {data, urlOps} = this.state;
        // let index = data.length - 1;
        let index = 0;
        const row = data.map((item,index)=>{
            return (
                <div key={index} className='list-item'>
                    <span className={['logo', `logo${index+1}`].join(' ')}><span style={{ display: 'inline-block', width: '0.23rem', height: '0.23rem', textAlign: 'center',position: 'absolute', color: 'rgba(153, 153, 153, 1)',fontSize: '0.1rem' }}>{index+1>5?index+1:''}</span></span>
                    <span style={{ marginRight: '0.25rem', width: '1.04rem',height: '0.2rem', display: 'inline-block', textAlign: 'center', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{item.customerName?item.customerName:'-'}</span>
                    <span style={{ width: '0.55rem', display: 'inline-block', textAlign: 'center' }}>{item.courseTimes?item.courseTimes:'-'}课次</span>
                </div>
            );
        })
        
        return (
            <div className='index_bg' style={{ background: 'rgba(50,197,169,0.2)' }}>
            <div className='charts-content'>
                    <div style={{ width: '100%', height: '0.07rem' }}></div>
                    <div className='content-title'></div>
                    <div className='list-title'>
                        <span style={{ marginRight: '0.72rem' }}>排名</span>
                        <span style={{ marginRight: '0.63rem' }}>账号</span>
                        <span>学习课次</span>
                    </div>
                    <div className='list-area'>
                            {data.length>0? <div className='am-list'>
                        {row}
                    </div>:(
                                <div className="noData">
                                    <div>暂无数据</div>
                                </div>
                            )}
                </div>
                </div>
            </div>
        );
    }
}
export default peaceSharkRank;


// WEBPACK FOOTER //
// ./src/peaceSharkIndex/index/rank.js